<template>
    <b-row>
        <b-col sm="12">
            <label>Remetente</label>
            <b-card no-body>
                <b-card-body>
                    <app-k-v
                        titulo="Enviada por"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        :dado="mensagem.enviadaPor"
                    ></app-k-v>
                    <app-k-v
                        titulo="Enviada em"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        :dado="$maskDateTime(mensagem.dataEnvio)"
                    ></app-k-v>
                    <app-k-v titulo="Status" :md="3" :lg="2" :xl="1">
                        <app-status :status="mensagem.statusDescr"></app-status>
                    </app-k-v>
                    <app-k-v
                        titulo="Status Leitura"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        v-if="mensagem.leituraStatusDescr != 'N/A'"
                    >
                        <app-status :status="mensagem.leituraStatusDescr"></app-status>
                    </app-k-v>
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
export default {
	props: {
		mensagem: {
			type: Object,
			default: () => ({})
		}
	}
}
</script>
